import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import DownloadLink from "PFApp/components/chat/download_link";
import { Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { Typography } from "PFComponents/typography";
import { useAttachments } from "PFCore/hooks/queries/attachments/use_attachments";
import { GIdTargetType } from "PFCore/types/gid";
import { useTranslation } from "react-i18next";

export const ActivityOverviewAttachments = () => {
  const { t } = useTranslation("activities", { keyPrefix: "show.details" });
  const { activityId } = useActivityShowContext();

  const { data: attachments } = useAttachments({
    targetId: Number(activityId),
    targetType: GIdTargetType.Task
  });

  if (!attachments || !attachments.entries?.length) {
    return null;
  }

  return (
    <Tile variant="light" paddingVariant="lg" data-qa-id="ActivityDetailsAttachments">
      <Stack gap="spacingLg">
        <Typography variant="h5">{t("attachments")}</Typography>
        <Stack>
          {attachments?.entries.map((attachment) => (
            <DownloadLink key={attachment.id} attachment={attachment} useIcon={false} />
          ))}
        </Stack>
      </Stack>
    </Tile>
  );
};
